import {User} from './../services/user.model';
import {AuthService} from './../services/auth.service';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import * as $ from 'jquery';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'pm-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit, AfterViewInit {
  public pageTitle = 'LOGIN';

  loginUserData: User = {
    email: '',
    password: null
  };
  error: boolean;
  errorMessage: string;

  constructor(private auth: AuthService, private router: Router, private spinnerService: NgxSpinnerService) {
    // clean any session params when service is initialize
    // localStorage.clear();
  }

  ngOnInit() {
    if (this.auth.isLoggedIn()) {
      this.router.navigate(['/monitor']);
    }
  }

  ngAfterViewInit() {
    $('body').addClass('backgroundLogin');
  }

  loginUser(): void {
    console.log('LoginComponent: loginUser: loginUserData: ', this.loginUserData);
    // Stored emails are lowercase and the lookup is case-sensitive
    const credentials = { ...this.loginUserData, email: (this.loginUserData.email || '').trim().toLowerCase() };
    this.auth.loginUser$(credentials).subscribe(
      res => {
        console.log('LoginComponent: loginUser: res: ', res);
        localStorage.setItem('sessionToken', res.sessionToken);
        localStorage.setItem('rolePermissions', JSON.stringify(res.permissions));
        this.auth.isAdmin = res.permissions.admin;
        console.log('LoginComponent: loginUser: isAdmin: ', this.auth.isAdmin);
        this.router.navigate(['/monitor']);
        this.auth.setLoggedIn(true);
      },
      err => {
        this.error = true;
        // console.log(err);
        // console.log(err.error.message);
        this.errorMessage = err.error.message;
      }
    );
    this.spinner();
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 2000);
  }
}
